const linkApi = {

    ASSIGNMENTS: {
        //課題一覧取得API
        LIST: '/subject/list'
    },
    
    DISH: {
        //料理大きさ一覧取得API
        DISH_SIZE_LIST: '/dish/dish-size-list',
        //カトラリー一覧取得API
        CUTLERY_LIST: '/dish/cutlery-list',
        //料理一覧検索API
        SEARCH_DISH: '/dish/search-dish',
        //食品一覧検索API
        SEARCH_FOOD: '/dish/search-food',
        //間食一覧検索API
        SEARCH_SNACK: '/dish/search-snack',
        //料理事典データ取得API
        ENCYCLOPEDIA: 'dish/encyclopedia',
        //間食一覧取得API
        SNACK_LIST: '/dish/snack-list',
        //Dish detail API
        DISH_DETAIL: '/dish/dish-detail',
    },

    LOGIN: {
        //ログイン認証API
        AUTH: '/login/auth',
        //ログインチェックAPI
        CHECK: '/login/check',
        //ログアウトAPI
        LOGOUT: '/login/logout',
    },

    PERSON_CONDITION: {
        //人物条件マスタ取得API
        ALL: '/person-condition/all'
    },

    SET_MENU: {
        //セットメニュー詳細取得API
        DETAIL: '/set-menu/detail',
        //セットメニュー一覧取得API
        LIST: '/set-menu/list',
    },

    USER: {
        //献立保存データ一覧取得API
        ALL_MENU_LIST: '/user/all-menu-list',
        //オリジナル料理作成API
        CREATE_DISH: '/user/create-dish',
        //献立表初回データ作成API
        CREATE_MENU_TABLE: '/user/create-menu-table',
        //献立表初回データ作成_課題用API
        CREATE_MENU_TABLE_SUBJECT: '/user/create-menu-table-subject',
        //オリジナル料理削除API
        DELETE_DISH: '/user/delete-dish',
        //オリジナル料理一覧取得API
        DISH_LIST: '/user/dish-list',
        //献立表保存データ詳細取得API
        MENU_TABLE: '/user/menu-table',
        //献立表保存データ一覧取得API
        MENU_TABLE_LIST: '/user/menu-table-list',
        //オリジナル料理保存API
        SAVE_DISH: '/user/save-dish',
        //献立データ保存_料理用API
        SAVE_MENU_FROM_DISH: '/user/save-menu-from-dish',
        //献立データ保存_既存献立用API
        SAVE_MENU_FROM_MENU: '/user/save-menu-from-menu',
        //献立データ保存_間食用API
        SAVE_MENU_FROM_SNACK: '/user/save-menu-from-snack',
        //献立データ保存_セットメニュー用API
        SAVE_MENU_FROM_SET: '/user/save-menu-from-set',
        //献立データ保存_選択メニュー用API
        SAVE_MENU_FROM_SUBJECT: '/user/save-menu-from-subject',
        //献立表データ保存API
        SAVE_MENU_TABLE: '/user/save-menu-table',
        //献立表データ削除API
        DELETE_MENU_TABLE: '/user/delete-menu-table',
        //献立データ削除API
        DELETE_MENU: '/user/delete-menu',
        //献立表提出API
        SUBMIT_MENU_TABLE: '/user/submit-menu-table',
        //ユーザー氏名登録API
        UPDATE_NAME: '/user/update-name',
        // 献立表の栄養素表データ取得API
        MENU_TABLE_TABLE: 'user/menu-table-table',
        // オリジナル料理使用中の献立取得API
        MENU_LIST_CHANGE_DISH: 'user/dish-use-menu-list',
        //オリジナル料理詳細取得API
        DISH_DETAIL: 'user/dish-detail',
        // SCHOOL_YEAR
        SCHOOL_YEAR: 'teacher/list-school-year',
        // UPDATE_OPTION_SET
        UPDATE_OPTION_SET: 'teacher/update-option-set',
        // COVER_IMAGE_HEIC
        COVER_IMAGE_HEIC: 'user/convert-heic',
    },

    TITLE: {
        //タイトル画面データ取得API
        DETAIL: '/title/detail',
    },

    GRAPH: {
        //献立表のグラフデータ取得API
        MENU_TABLE : 'graph/menu-table',
        //献立のグラフデータ取得API
        MENU : 'graph/menu',
        //セットメニューのグラフデータ取得API
        SET_MENU : 'graph/set-menu',
        //選択メニューのグラフデータ取得API,
        SUBJECT_MENU: 'graph/subject-menu',
        //栄養素のグラフ・表データ取得API
        NUTRIENTS_DATA: 'graph/nutrients-data',
        //4群のグラフ・表データ取得API
        GROUP4_DATA: 'graph/group4-data',
        //6群のグラフ・表データ取得API
        GROUP6_DATA: 'graph/group6-data',
    },
    CLASSIFY_SHEET: {
        MENU_TABLE_FOOD_LIST: 'classify-sheet/menu-table-food-list',
        SAVE_MENU_TABLE_FOOD: 'classify-sheet/save-menu-table-food',
        MAIN_FOOD_LIST: 'classify-sheet/main-food-list'
    },

    BOX_SUBMIT_LIST: 'submit-box/list',

}
export default linkApi;